import React from 'react';
const BookIcon = ({ size=20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 4h14v16H3z" />
    <path d="M17 4h4v16h-4" />
    <path d="M7 8h6" />
    <path d="M7 12h4" />
  </svg>
);
export default BookIcon;